import Index from '../components/CategoryProductOrder/Index';

let routes = {
    path: '/categoryProductOrder',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/categoryProductOrder',
            component: Index
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/categoryProductOrder.js